const DEVICE_ID_KEY = "socialocean_device_id";

/**
 * Returns the stable per-browser device id used by the buy-again widget for
 * both PostHog identity (via bootstrap) and Shopify pixel event tagging.
 *
 * Persists in `localStorage` so the same browser keeps a stable id across
 * sessions and tabs. Generated as a UUID on first access.
 */
export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") return "";
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `v_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
